import React from "react";

const RiskExposurePlaceholder = () => {
  return (
    <div className="p-2 risk-exposure-list">
      <div
        className="card rounded-4 shadow-sm h-100 overflow-hidden"
        style={{ width: 560, minWidth: 500, backgroundColor: "#f9f9f9" }}
      >
        <div className="card-body d-flex flex-column">
          <div className="card-title h-4 text-center mb-3 pt-3 fw-bold text-dark">
            Risk Exposure List
          </div>

          {/* Header Row */}
          <div
            className="col-12 mb-3 d-flex px-3"
            style={{ fontSize: 16, fontWeight: 600 }}>
            <div className="text-center" style={{ width: "60%", marginRight: 4 }}>
              Vulnerability
            </div>
            <div className="text-center" style={{ width: "20%", marginRight: 4 }}>
              Severity
            </div>
            <div className="text-center" style={{ width: "20%" }}>
              CVSS
            </div>
          </div>

          {/* Placeholder Rows */}
          <div className="px-4">
            {[...Array(5)].map((_, index) => (
              <div
                className="py-2 d-flex flex-row align-items-center border-bottom"
                key={index}>
                <div style={{ width: 300 }}>
                  <span className="placeholder-glow">
                    <span className="placeholder col-10 rounded" />
                  </span>
                </div>
                <div>
                  <span className="placeholder-glow">
                    <span
                      className="placeholder rounded-pill fw-bold fs-6 px-2 py-1 my-1"
                      style={{ width: 100, height: 24, display: "inline-block" }}
                    />
                  </span>
                </div>
                <div>
                  <span className="placeholder-glow ms-3">
                    <span
                      className="placeholder rounded"
                      style={{ width: 40, height: 22, display: "inline-block" }}
                    />
                  </span>
                </div>
              </div>
            ))}
          </div>

          {/* Footer Button Placeholder */}
          <div className="position-absolute bottom-0 start-50 translate-middle-x">
            <div className="p-3 w-100 text-center">
              <span
                className="placeholder rounded-3"
                style={{ width: 213.63, height: 45 }} />
            </div>
          </div>          
        </div>
      </div>
    </div>
  );
};

export default RiskExposurePlaceholder;